import React from "react";

export const ReferalsCopyIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 10.9V15.1C14 18.6 12.6 20 9.1 20H4.9C1.4 20 0 18.6 0 15.1V10.9C0 7.4 1.4 6 4.9 6H9.1C12.6 6 14 7.4 14 10.9Z"
        fill="#C6B7FF"
      />
      <path
        d="M15.0996 0H10.8996C7.81646 0 6.37052 1.09409 6.06929 3.73901C6.00627 4.29235 6.46454 4.75 7.02145 4.75H9.09958C13.2996 4.75 15.2496 6.7 15.2496 10.9V12.9781C15.2496 13.535 15.7072 13.9933 16.2606 13.9303C18.9055 13.629 19.9996 12.1831 19.9996 9.1V4.9C19.9996 1.4 18.5996 0 15.0996 0Z"
        fill="#C6B7FF"
      />
    </svg>
  );
};
